<script>
    import DefaultApp from '../defaultApp';
    import bulmaCollapsible from '@creativebulma/bulma-collapsible';
    import mixin from '../mixin';
    export default {
        mixins: [mixin],
        props: {
            invoices: Array,
            showAllVorderingen: String,
            showLessVorderingen: String,
            totalAmountText: String,
            chosenErrorText: String,
            chosenError: Boolean,
            type: {
                type: String,
                default: 'checkbox'
            },
            allSelected: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                ...DefaultApp.data(),
                inputVals: []
            }
        },
        computed: {
            totalAmount() {
                return this.invoices.reduce((accumulator, invoice) => accumulator + invoice.amount, 0);
            }
        },
        methods: {
            ...DefaultApp.methods,
            updateSelection(val) {
                if (this.type === 'checkbox') {
                    const index = this.inputVals.indexOf(val);
                    if (index !== -1) {
                        this.inputVals.splice(index, 1);
                    } else {
                        this.inputVals.push(val);
                    }
                    this.$emit('update:modelValue', this.inputVals);
                } else {
                    this.$emit('update:modelValue', val);
                }
            }
        },
        mounted() {
            if (this.invoices.length > 10) {
                this.$nextTick(() => {
                    bulmaCollapsible.attach('.is-collapsible');
                });
            }
            if (this.allSelected) {
                this.invoices.forEach(invoice => {
                    this.updateSelection(invoice.id);
                });
            }
        }
    }
</script>

<template>
    <div class="table-container">
        <table class="table is-fullwidth table--collapsable">
            <colgroup>
                <col width="5%">
                <col width="12%">
                <col width="67.5%">
                <col width="2.5%">
                <col width="13%">
            </colgroup>
            <tbody>
                <tr v-for="invoice in invoices.slice(0, 10)" :key="invoice.id">
                    <td v-if="type === 'checkbox'">
                        <input type="checkbox" class="by-checkbox" :checked="allSelected" name="ClaimCheckboxGroupCustomer" @change="updateSelection($event.target.value)" :id="invoice.id" :value="invoice.id"><label :for="invoice.id" class="by-checkable"></label>
                    </td>
                    <td v-else>
                        <input type="radio" class="by-radio" name="ClaimCheckboxGroupCustomer" @change="updateSelection($event.target.value)" :id="invoice.id" :value="invoice.id"><label :for="invoice.id" class="by-checkable mt-1"></label>
                    </td>
                    <td v-html="invoice.id"></td>
                    <td>
                        {{ invoice.description }}
                    </td>
                    <td class="pr-0">
                        &euro;
                    </td>
                    <td align="right">
                        {{ toEuro(invoice.amount) }}
                    </td>
                </tr>
                <tr class="collapse-toggle" v-if="invoices.length > 10">
                    <td colspan="5" align="center" class="p-0">
                        <div id="collapseTable" class="is-collapsible is-borderless">
                            <table class="table is-fullwidth">
                                <colgroup>
                                    <col width="5%">
                                    <col width="12%">
                                    <col width="67.5%">
                                    <col width="2.5%">
                                    <col width="13%">
                                </colgroup>
                                <tbody>
                                    <tr v-for="invoice in invoices.slice(10, invoices.length)" :key="invoice.id">
                                        <td v-if="type === 'checkbox'">
                                            <input type="checkbox" class="by-checkbox" :checked="allSelected" name="ClaimCheckboxGroupCustomer" @change="updateSelection($event.target.value)" :id="invoice.id" :value="invoice.id"><label :for="invoice.id" class="by-checkable"></label>
                                        </td>
                                        <td v-else>
                                            <input type="radio" class="by-radio" name="ClaimCheckboxGroupCustomer" @change="updateSelection($event.target.value)" :id="invoice.id" :value="invoice.id"><label :for="invoice.id" class="by-checkable"></label>
                                        </td>
                                        <td v-html="invoice.id"></td>
                                        <td>
                                            {{ invoice.description }}
                                        </td>
                                        <td class="pr-0">
                                            &euro;
                                        </td>
                                        <td align="right">
                                            {{ toEuro(invoice.amount) }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <a href="#collapseTable" class="collapse-trigger collapse-trigger-readmore is-justify-content-center has-text-link mt-0" data-action="collapse"><span :data-readmore="showAllVorderingen" :data-readless="showLessVorderingen">{{ showAllVorderingen }}</span> <span class="icon"><i class="fa-solid fa-chevron-down"></i></span></a>
                    </td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <th colspan="3" class="border">{{ totalAmountText }}</th>
                    <td class="has-text-weight-bold pr-0">&euro;</td>
                    <td class="has-text-weight-bold" align="right">{{ toEuro(totalAmount) }}</td>
                </tr>
                <tr v-if="chosenError">
                    <td colspan="5">
                        <span class="form-error has-text-danger">
                            {{ chosenErrorText }}
                        </span>
                    </td>
                </tr>
            </tfoot>
        </table>
    </div>
</template>